import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { StatefulPopover, TRIGGER_TYPE } from 'baseui/popover';
import { PLACEMENT } from 'baseui/toast';
import { useTranslation } from 'react-i18next';

import { IObjProps } from 'shared/consts/types';
import DownTriangularArrow from 'shared/icons/DownTriangularArrow';
import UpTriangularArrow from 'shared/icons/UpTriangularArrow';

const getCCList = (ccList: Array<any>) => ccList.join(', ');

const Recipients = ({
	ccList,
	colors,
	isTicketScreen,
}: {
	ccList: Array<string>;
	colors: IObjProps;
	isTicketScreen?: boolean;
}) => {
	const [css, theme]: [any, any] = useStyletron();
	const { t } = useTranslation(['components']);

	const [isOpen, setIsOpen] = useState<boolean>(false);

	return (
		<StatefulPopover
			overrides={{
				Inner: {
					style: {
						backgroundColor: 'transparent',
					},
				},
				Body: {
					style: ({ $theme }: any) => ({
						backgroundColor: 'transparent',
						zIndex: $theme.zIndex300,
					}),
				},
			}}
			dismissOnEsc
			dismissOnClickOutside
			popoverMargin={5}
			placement={isTicketScreen ? PLACEMENT.bottom : PLACEMENT.bottomLeft}
			triggerType={TRIGGER_TYPE.click}
			onClose={() => {
				setIsOpen(false);
			}}
			onOpen={() => {
				setIsOpen(true);
			}}
			content={() => (
				<div
					className={css({
						backgroundColor: theme.inputFillModal,
						width: isTicketScreen ? '14rem' : '16rem',
						color: theme.modalTextColor,
						display: 'flex',
						paddingTop: '0.625rem',
						paddingBottom: '0.625rem',
						paddingLeft: '0.625rem',
						paddingRight: '0.625rem',
						borderTopRightRadius: '0.5rem',
						borderTopLeftRadius: '0.5rem',
						borderBottomLeftRadius: '0.5rem',
						borderBottomRightRadius: '0.5rem',
						maxHeight: '7.25rem',
						overflow: 'auto',
					})}
				>
					<div
						className={css({
							fontSize: '0.625rem',
							marginRight: '0.25rem',
							height: '1rem',
							lineHeight: '1rem',
							color: theme.colors.accent50,
						})}
					>
						{`${t('components:emailMessagesPreview.cc')}:`}
					</div>
					<div
						className={css({
							flexGrow: 1,
							fontSize: '0.625rem',
							lineHeight: '1rem',
						})}
					>
						{getCCList(ccList)}
					</div>
				</div>
			)}
		>
			<div
				className={css({
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer',
				})}
			>
				{isOpen ? <UpTriangularArrow fill={colors.text} /> : <DownTriangularArrow fill={colors.text} />}
			</div>
		</StatefulPopover>
	);
};

export default React.memo(Recipients);
